import { createClient } from '@supabase/supabase-js';

import type { Database } from './types';

const supabaseUrl = import.meta.env['VITE_SUPABASE_URL'];
const supabaseAnonKey = import.meta.env['VITE_SUPABASE_ANON_KEY'];

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY');
}

const REMEMBER_KEY = 'lendaris.auth.remember';

export const setRememberMe = (remember: boolean) => {
  if (typeof window === 'undefined') return;
  if (remember) {
    window.localStorage.setItem(REMEMBER_KEY, '1');
  } else {
    window.localStorage.removeItem(REMEMBER_KEY);
  }
};

export const getRememberMe = (): boolean => {
  if (typeof window === 'undefined') return true;
  return window.localStorage.getItem(REMEMBER_KEY) === '1';
};

const hybridStorage = {
  getItem: (key: string): string | null => {
    if (typeof window === 'undefined') return null;
    return (
      window.localStorage.getItem(key) ?? window.sessionStorage.getItem(key)
    );
  },
  setItem: (key: string, value: string): void => {
    if (typeof window === 'undefined') return;
    const target = getRememberMe() ? window.localStorage : window.sessionStorage;
    const other = getRememberMe() ? window.sessionStorage : window.localStorage;
    target.setItem(key, value);
    other.removeItem(key);
  },
  removeItem: (key: string): void => {
    if (typeof window === 'undefined') return;
    window.localStorage.removeItem(key);
    window.sessionStorage.removeItem(key);
  },
};

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storage: hybridStorage,
  },
});
